// eslint-disable-next-line no-restricted-imports
import { sendGTMEvent as _sendGTMEvent } from '@next/third-parties/google';
import { authStore } from '@wwe-portal/web/providers/stores/auth-store';

export const sendGTMEvent = (data: object) => {
  _sendGTMEvent({
    ...data,
    userId: authStore.getState().currentUser?.userId,
  });
};
